import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const STATUSES = ["New", "Qualified", "Contacted", "Demo", "Proposal", "Negotiation", "Won", "Lost"];

export default function AdminLeads() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/leads").then((r) => setItems(r.data.items));
    useEffect(() => { load(); }, []);

    const update = async (id, status) => {
        try {
            await api.patch(`/admin/leads/${id}`, { status });
            toast.success(`Lead → ${status}`);
            load();
        } catch { toast.error("Update failed"); }
    };

    return (
        <div data-testid="admin-leads-page">
            <div className="eyebrow eyebrow--slate">Leads</div>
            <h1 className="font-serif text-4xl text-navy mt-3">Lead Management</h1>
            <div className="mt-8 bg-white border border-slate-200 rounded-xl overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-slate-50 text-slate-500 text-xs uppercase font-mono">
                        <tr>
                            <th className="text-left px-4 py-3">Ref</th>
                            <th className="text-left px-4 py-3">Contact</th>
                            <th className="text-left px-4 py-3">Organization</th>
                            <th className="text-left px-4 py-3">Product</th>
                            <th className="text-left px-4 py-3">Source</th>
                            <th className="text-left px-4 py-3">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((l) => (
                            <tr key={l.lead_id} className="border-t border-slate-100" data-testid={`lead-row-${l.reference}`}>
                                <td className="px-4 py-3 font-mono text-xs">{l.reference}</td>
                                <td className="px-4 py-3">
                                    <div className="text-navy">{l.contact_name}</div>
                                    <div className="text-slate-400 text-xs">{l.email}</div>
                                </td>
                                <td className="px-4 py-3">{l.organization}</td>
                                <td className="px-4 py-3">{l.product || "—"}</td>
                                <td className="px-4 py-3 text-slate-500 text-xs">{l.source}</td>
                                <td className="px-4 py-3">
                                    <select value={l.status} onChange={(e) => update(l.lead_id, e.target.value)} className="border border-slate-200 rounded px-2 py-1 text-xs bg-white" data-testid={`lead-status-${l.reference}`}>
                                        {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                                    </select>
                                </td>
                            </tr>
                        ))}
                        {!items.length && <tr><td colSpan={6} className="px-4 py-12 text-center text-slate-400">No leads yet</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
